@if (completingSignIn()) {
  <section class="auth-callback">
    <mat-progress-spinner diameter="32" mode="indeterminate" />
    <p>Signing you in…</p>
  </section>
}
